module.exports = __webpack_public_path__ + "img/w3_trash_delete_grey.ffa04cac.png";